export const SITE_CONFIG = {
  name: '”おもいむすび”',
  tagline: 'AIがWBSとガントチャートを自動生成。日報から進捗が自動更新されるプロジェクト管理ツール。',
  description: '資料をアップロードするだけで、AIがタスク分解・ガントチャート作成・マイルストーン設定を自動化。日々の日報から進捗を更新し、ファイル・チャット・タスクをひとつの画面で管理できます。',
  appUrl: 'https://app.omoimusubi.asia/login',
  signupUrl: 'https://app.omoimusubi.asia/login?mode=company',
  companyName: '株式会社cafoot',
  companyAddress: '〒155-0034 東京都世田谷区代沢3-16-16 STEP101',
  companyPhone: '',
  companyEmail: '',
  basePrice: '40,000',
  projectPrice: '5,000',
  userPrice: '500',
  freeTrialDays: 14,
  supportedLanguages: ['日本語', '英語', 'タイ語'],
} as const;

/** 💰公開料金API（アプリの⚙️料金設定と自動連動。取得失敗時は上の既定値で表示） */
export const CONTACT_API = 'https://app.omoimusubi.asia/api/public/contact';
export const PRICING_API = 'https://app.omoimusubi.asia/api/public/pricing';